/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_ConnectionInputs */

const en_mobile_upload_error_connection = /** @type {(inputs: Mobile_Upload_Error_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't connect right now. Please try again.`)
};

const es_mobile_upload_error_connection = /** @type {(inputs: Mobile_Upload_Error_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos conectarnos ahora. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We couldn't connect right now. Please try again." |
*
* @param {Mobile_Upload_Error_ConnectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_connection = /** @type {((inputs?: Mobile_Upload_Error_ConnectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_ConnectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_connection(inputs)
	return en_mobile_upload_error_connection(inputs)
});